import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";

import css from './MenuCategoriesListComponent.module.css';
import {menuCategoriesActions} from "../../../store/slices/settings-slices";
import MenuCategoryComponent from "../MenuCategoryComponent/MenuCategoryComponent";


const MenuCategoriesListComponent = ({setIsOpenUpdate}) => {
    const {menuCategories, trigger} = useSelector(store => store.menuCategories);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(menuCategoriesActions.getAllMenuCategories());
    }, [trigger]);


    return (
        <section className={css.wrap}>
            {menuCategories && menuCategories.map((obj) => <MenuCategoryComponent
                key={obj.id}
                menuCategory={obj}
                setIsOpenUpdate={setIsOpenUpdate}
            />)
            }
        </section>
    );
};

export default React.memo(MenuCategoriesListComponent);